.c-product-lister-isolated {
  all: unset;
  display: block;
  isolation: isolate;
  > * {
    all: unset;
  }
}
